<template>
  <v-app>
    <v-main>
      <v-container class="pa-0 fill-height" fluid>
        <v-row class="fill-height pa-0 ma-0">
          <v-col class="imredd-bg" cols="12" md="6" sm="12" lg="4" xl="4">
            <v-row
              class="py-7 fill-height pos-relative"
              align="center"
              justify="center"
            >
              <v-col cols="12" md="10" lg="9">
                <img src="@/assets/logo_black.png" height="70px" />
                <div class="h4 font-weight-light my-5">
                  Welcome ! <br />
                  Please, login to your account
                </div>

                <v-text-field
                  v-model="email"
                  name="email"
                  placeholder="E-mail"
                  :error-messages="errors.email"
                  autofocus
                  class="input-group--focused"
                  @blur="$v.email.$touch()"
                />
                <v-text-field
                  v-model="password"
                  name="password"
                  :error-messages="errors.password"
                  :type="passwordType"
                  autocomplete="off"
                  placeholder="Password"
                  :append-icon="eyeIcon"
                  @keyup.enter="submit"
                  @click:append="togglePassword"
                  @blur="$v.password.$touch()"
                />
                <v-btn
                  dark
                  large
                  block
                  :disabled="false"
                  color="primary"
                  class="my-3"
                  @click="submit"
                  @keyup.enter="submit"
                >
                  Sign in
                </v-btn>
                <!-- <v-btn dark large block @click="submit" @keyup.enter="submit" disabled color="pink" class="my-3" >Sign in</v-btn> -->
                <ForgottenPasswordDialog /><br />
                <resend-activation-email />
                <div class="text-center">
                  <img
                    class="mt-2 powered_by"
                    src="@/assets/powered_by_himydata_blue.png"
                    height="35px"
                    contain
                  />
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="bg-cover hidden-xs-only hidden-sm-only md-6 lg-8 xl-8"
          />
        </v-row>
        <error-handler />
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import ForgottenPasswordDialog from "@/components/utils/ForgottenPasswordDialog"
import ResendActivationEmail from "@/components/utils/ResendActivationEmail"
import ErrorHandler from "@/components/utils/ErrorHandler"
import { validationMixin } from "vuelidate"
import { required, email } from "vuelidate/lib/validators"
import { AccountService, BrandService } from "@/services"
export default {
  components: {
    ErrorHandler,
    ForgottenPasswordDialog,
    ResendActivationEmail
  },
  mixins: [validationMixin],
  validations: {
    password: { required },
    email: { email, required }
  },
  data: function() {
    return {
      email: "",
      password: "",
      eyeIcon: "mdi-eye",
      passwordType: "password"
    }
  },
  computed: {
    errors() {
      const errors = {
        password: [],
        email: []
      }

      if (this.$v.password.$dirty) {
        !this.$v.password.required &&
          errors.password.push("Password is required")
      }
      if (this.$v.email.$dirty) {
        if (!this.$v.email.email) {
          errors.email.push("Email is not valid")
        }
        if (!this.$v.email.required) {
          errors.email.push("Email is required")
        }
      }

      return errors
    }
  },
  mounted: function() {
    this.clear()
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.call_login()
      }
    },
    call_login() {
      var credentials = {
        email: this.email,
        password: this.password
      }

      let t = this
      AccountService.login(this, credentials, this.$route.query.redirect).then(
        r => {
          t.getBrands()
        }
      )
    },
    clear() {
      this.$v.$reset()
      this.email = ""
      this.password = ""
      this.checkbox = null
    },
    togglePassword() {
      this.passwordType = this.passwordType == "password" ? "text" : "password"
      this.eyeIcon = this.eyeIcon == "mdi-eye" ? "mdi-eye-off" : "mdi-eye"
    },
    getBrands() {
      this.isLoading = true

      BrandService.all(this)
        .then(result => {
          this.$store.commit("setBrands", result)
          this.$store.commit("setGlobalBrand", result)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
<style>
.imredd-bg {
  background-color: white;
}
.pos-relative {
  position: relative;
}
.bg-cover {
  background-color: #ff505c;
  background-size: cover;
  background-position: 50% 50%;
  background-image: url(../../assets/signin_cover.png);
}
.powered_by {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: 15px;
}
</style>
